/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const useBookingData = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    product,
    searchCriteria,
    selectedTime,
    recurrenceData: initialRecurrenceData,
    updatedTimes: initialUpdatedTimes = {},
    occurrenceDates: initialOccurrenceDates,
    availabilityData: initialAvailabilityData,
    fromReviewSchedule = false,
    bookingConfirmed = false
  } = location.state || {};

  const companyPrimaryId = useSelector((state) => state.companyReducer.company.primaryId);
  const userAccount = useSelector((state) => state?.auth?.data) || {};
  const companyState = useSelector((state) => state?.companyReducer?.company) || {};
  const isAuthenticated = useSelector((state) => state?.auth?.isAuthenticated);

  const slotIntervalInMinutes = companyState?.workingSchedule?.slotIntervalInMinutes || 60;
  const guestAccountId = sessionStorage.getItem('guestAccountId') || null;
  const accountIdforPostMessage = userAccount?.account?.primaryId || guestAccountId;
  const userPrimaryId = userAccount?.account?.primaryId;

  return {
    product,
    searchCriteria,
    selectedTime,
    initialRecurrenceData,
    initialUpdatedTimes,
    initialOccurrenceDates,
    initialAvailabilityData,
    fromReviewSchedule,
    bookingConfirmed,
    companyPrimaryId,
    userAccount,
    companyState,
    isAuthenticated,
    slotIntervalInMinutes,
    guestAccountId,
    accountIdforPostMessage,
    userPrimaryId,
    dispatch
  };
};

export default useBookingData;